import { render, staticRenderFns } from "./zhenliao-detail.vue?vue&type=template&id=70b934e3&scoped=true&"
import script from "./zhenliao-detail.vue?vue&type=script&lang=ts&"
export * from "./zhenliao-detail.vue?vue&type=script&lang=ts&"
import style0 from "./zhenliao-detail.vue?vue&type=style&index=0&id=70b934e3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b934e3",
  null
  
)

export default component.exports